// removed by extract-text-webpack-plugin
module.exports = {"mono":"InputValueEditor__mono___2yzd3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InputValueEditor/InputValueEditor.css
// module id = 963
// module chunks = 0